import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext, CartContext } from '@/App';
import { ShoppingCart, User, LogOut, LayoutDashboard } from 'lucide-react';

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const { cart } = useContext(CartContext);
  const navigate = useNavigate();

  const cartItemsCount = cart.reduce((total, item) => total + item.quantity, 0);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="text-2xl font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-amber-600 via-amber-500 to-amber-700">
              Le Comptoir de Clément
            </div>
          </Link>

          {/* Navigation */}
          <div className="flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-gray-900 transition font-medium text-sm">
              Produits
            </Link>

            <Link to="/contact" className="text-gray-700 hover:text-gray-900 transition font-medium text-sm">
              Contact
            </Link>

            {user && (
              <Link to="/orders" className="text-gray-700 hover:text-gray-900 transition font-medium text-sm">
                Mes Commandes
              </Link>
            )}

            {user?.role === 'admin' && (
              <Link to="/admin" className="flex items-center space-x-2 text-gray-700 hover:text-gray-900 transition font-medium text-sm">
                <LayoutDashboard size={18} />
                <span>Admin</span>
              </Link>
            )}

            {/* Cart */}
            <Link to="/cart" className="relative flex items-center space-x-1 text-gray-700 hover:text-gray-900 transition">
              <ShoppingCart size={22} />
              {cartItemsCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-gradient-to-r from-amber-500 to-amber-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold shadow-lg">
                  {cartItemsCount}
                </span>
              )}
            </Link>

            {/* User Menu */}
            {user ? (
              <div className="flex items-center space-x-6">
                <div className="flex items-center space-x-2">
                  <div className="w-8 h-8 bg-gradient-to-br from-slate-700 to-slate-900 rounded-full flex items-center justify-center">
                    <User size={16} className="text-white" />
                  </div>
                  <span className="text-sm font-medium text-gray-900">{user.full_name}</span>
                </div>
                <button
                  onClick={handleLogout}
                  className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition text-sm"
                >
                  <LogOut size={18} />
                  <span>Déconnexion</span>
                </button>
              </div>
            ) : (
              <div className="flex items-center space-x-4">
                <Link to="/login" className="text-gray-700 hover:text-gray-900 transition font-medium text-sm">
                  Connexion
                </Link>
                <Link
                  to="/register"
                  className="bg-gradient-to-r from-slate-800 to-slate-900 text-white px-6 py-2.5 rounded-lg hover:from-slate-900 hover:to-black transition shadow-sm font-medium text-sm"
                >
                  Inscription
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;